import { render, staticRenderFns } from "./PaymentInquiry2.vue?vue&type=template&id=7b22df87&scoped=true"
import script from "./PaymentInquiry2.vue?vue&type=script&lang=js"
export * from "./PaymentInquiry2.vue?vue&type=script&lang=js"
import style0 from "./PaymentInquiry2.vue?vue&type=style&index=0&id=7b22df87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b22df87",
  null
  
)

export default component.exports